import { useNavigate, useLocation } from 'react-router-dom'

import { pagesDictionary } from '@/utils/dictionaries/pagesDictionary/pagesDictionary'

const routeParamToReplace = /\[.*]/
const routeRegexParam = '(?!.*\\/).*'
const fallbackRoutes = Object.keys(pagesDictionary).map((route) =>
  route.replace(routeParamToReplace, routeRegexParam.toString()).concat('$')
)

export const isRouteValid = (asPath: string) => fallbackRoutes.some((route) => new RegExp(route).test(asPath))

const NotFoundPage = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  if (isRouteValid(pathname)) navigate(pathname)
  else if (pathname.includes('undefined')) navigate('/home')

  return null
}

export { NotFoundPage }
